import { ErpCountryValue } from 'app/rm/erp/common/person/model/person-values';
import {
    ErpDestinationValue, ErpTravelManagementPurposeValue,
    ErpArrivalValue, ErpReturnTripValue, ErpBillingbasisValue
} from '../../shared/model/travelmanagement-values';

export class TravelData {
    countrySelected?: ErpCountryValue;
    country?: string;
    destinationSelected?: ErpDestinationValue;
    destination?: string;
    travelManagementPurposeSelected?: ErpTravelManagementPurposeValue;
    travelManagementPurpose?: string;
    arrivalSelected?: ErpArrivalValue;
    returnTripSelected?: ErpReturnTripValue;
    destinationFreetext?: string;

    tripBeginDate?: Date;
    tripEndDate?: Date;
    businessBeginDate?: Date;
    businessEndDate?: Date;

    billingbasisSelected?: ErpBillingbasisValue;
}
